import { memo } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import { PortableTextBlock } from 'next-sanity'
import LockIcon from 'public/static/campaigns/lock.svg'
import SoldOut from 'public/static/campaigns/rewards-program/sold-out.webp'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'

import styles from './PrizeItem.module.scss'

interface PrizeItemProps {
  id: string
  isDisabled?: boolean
  image: {
    url: string
    alt: string
  }
  textBtn: PortableTextBlock[]
  header: string
  variant?: 'blocked' | 'unblocked'
  isSoldOut?: boolean
}

const PrizeItem = memo(
  ({
    id,
    isDisabled = false,
    image,
    textBtn,
    header,
    variant = 'blocked',
    isSoldOut = false
  }: PrizeItemProps) => {
    return (
      <li
        className={clsx(styles.wrapper, { [styles.disabled]: isDisabled })}
        id={id}
      >
        <div className={clsx(styles.content, { [styles.soldOut]: isSoldOut })}>
          {variant === 'blocked' && (
            <div className={styles.lockIconWrapper}>
              <LockIcon alt='ikona kłódki' />
            </div>
          )}
          <div className={styles.imageWrapper}>
            <Image
              src={image.url}
              alt={image.alt}
              fill
              style={{ objectFit: 'contain' }}
              priority
            />
          </div>

          <div
            className={clsx(
              styles.btn,
              variant === 'blocked' ? styles.btnBlocked : styles.btnUnblocked
            )}
          >
            <CustomPortableText value={textBtn} />
          </div>
          <p className={styles.description}>{header}</p>
        </div>
        {isSoldOut && (
          <Image
            className={styles.soldOutStamp}
            src={SoldOut}
            alt={`Nagroda została wyprzedana`}
            width={480}
            height={480}
          />
        )}
      </li>
    )
  }
)

export default PrizeItem
